import { CircularProgress, Typography } from '@material-ui/core'
import * as React from 'react'
import useStyles from './style'

type LoadingSpinnerProps = {
  color?: string,
  size?: number,
  text?: string,
  textSize?: string,
  textColor?: string,
  thickness?: number,
  horizontal?: boolean,
}

const LoadingSpinner: React.FunctionComponent<LoadingSpinnerProps> = ({
  color = 'rgb(97, 64, 255)',
  size = 54,
  text,
  textColor = 'rgb(97, 64, 255)',
  thickness = 4,
  horizontal = false,
  textSize = 12
}) => {
  const classes = useStyles({ color, textColor, horizontal, textSize })
  return (
    <div className={classes.root}>
      <CircularProgress
        className={classes.bottom}
        size={size}
        thickness={thickness}
        value={100}
        variant="determinate"
      />
      <CircularProgress
        classes={{
          circle: classes.circle
        }}
        className={classes.top}
        disableShrink
        variant="indeterminate"
        size={size}
        thickness={thickness}
      />
      {text && (
        <Typography className={classes.text}>
          {text}
        </Typography>
      )}
    </div>
  )
}

export default LoadingSpinner
